export const defaultStoreCategories = [
  {
    id: "vestuario",
    label: "Vestuario",
    description: "Camisas, polos e uniformes",
    icon: "package",
  },
  {
    id: "papelaria",
    label: "Papelaria",
    description: "Cartoes e materiais impressos",
    icon: "file",
  },
  {
    id: "brindes",
    label: "Brindes",
    description: "Canecas, kits e itens promocionais",
    icon: "gift",
  },
  {
    id: "sinalizacao",
    label: "Sinalizacao",
    description: "Banners e materiais de ponto de venda",
    icon: "image",
  },
];

export const promotionProducts = [
  {
    id: "camisa-polo-premium",
    name: "Camisa Polo Premium",
    category: "vestuario",
    price: 79.9,
    originalPrice: 99.9,
    badge: "20% OFF",
    subtitle: "Malha confortavel com bordado institucional.",
    minOrder: "Pedido minimo: 4 unidades",
    delivery: "Entrega media: 7 dias",
    artLabel: "POLO",
    artSubLabel: "Linha oficial",
    tone: "midnight",
  },
  {
    id: "kit-cartao-visitas",
    name: "Kit Cartao de Visitas",
    category: "papelaria",
    price: 54.9,
    originalPrice: 69.9,
    badge: "Economize 15%",
    subtitle: "500 unidades com acabamento fosco premium.",
    minOrder: "Pedido minimo: 1 kit",
    delivery: "Entrega media: 5 dias",
    artLabel: "CARD",
    artSubLabel: "500 unidades",
    tone: "aurora",
  },
  {
    id: "caneca-vitrine",
    name: "Caneca Personalizada",
    category: "brindes",
    price: 32.5,
    originalPrice: 39.9,
    badge: "Oferta da semana",
    subtitle: "Caneca ceramica ideal para presentear clientes.",
    minOrder: "Pedido minimo: 6 unidades",
    delivery: "Entrega media: 6 dias",
    artLabel: "MUG",
    artSubLabel: "Brinde premium",
    tone: "sunrise",
  },
  {
    id: "banner-balcao",
    name: "Banner de Balcao",
    category: "sinalizacao",
    price: 119.9,
    originalPrice: 149.9,
    badge: "Leve mais por menos",
    subtitle: "Material rigido com comunicacao visual padronizada.",
    minOrder: "Pedido minimo: 1 unidade",
    delivery: "Entrega media: 8 dias",
    artLabel: "DISPLAY",
    artSubLabel: "Balcao e vitrine",
    tone: "ocean",
  },
];

export const featuredProducts = [
  {
    id: "camiseta-casual",
    name: "Camiseta Casual Store",
    category: "vestuario",
    price: 49.9,
    badge: "Novo",
    subtitle: "Modelo leve para a rotina da equipe.",
    minOrder: "Pedido minimo: 4 unidades",
    delivery: "Entrega media: 7 dias",
    artLabel: "TSHIRT",
    artSubLabel: "Uniforme leve",
    tone: "forest",
  },
  {
    id: "papel-timbrado",
    name: "Papel Timbrado",
    category: "papelaria",
    price: 42.9,
    badge: "Essencial",
    subtitle: "Bloco com identidade visual pronta para sua operacao.",
    minOrder: "Pedido minimo: 2 blocos",
    delivery: "Entrega media: 5 dias",
    artLabel: "A4",
    artSubLabel: "Impressos oficiais",
    tone: "pearl",
  },
  {
    id: "kit-boas-vindas",
    name: "Kit Boas-vindas",
    category: "brindes",
    price: 138.9,
    badge: "Mais vendido",
    subtitle: "Combo com caneca, bloco e pasta para novos clientes.",
    minOrder: "Pedido minimo: 1 kit",
    delivery: "Entrega media: 6 dias",
    artLabel: "KIT",
    artSubLabel: "Ativacao comercial",
    tone: "berry",
  },
  {
    id: "cartaz-vitrine-a3",
    name: "Cartaz Vitrine A3",
    category: "sinalizacao",
    price: 28.9,
    badge: "Reposicao rapida",
    subtitle: "Cartaz para ofertas, campanhas e ativacoes locais.",
    minOrder: "Pedido minimo: 3 unidades",
    delivery: "Entrega media: 4 dias",
    artLabel: "A3",
    artSubLabel: "Campanhas locais",
    tone: "citrus",
  },
  {
    id: "pasta-apresentacao",
    name: "Pasta de Apresentacao",
    category: "papelaria",
    price: 24.9,
    badge: "Profissional",
    subtitle: "Pasta institucional para propostas e contratos.",
    minOrder: "Pedido minimo: 10 unidades",
    delivery: "Entrega media: 5 dias",
    artLabel: "FOLDER",
    artSubLabel: "Atendimento premium",
    tone: "midnight",
  },
  {
    id: "sacola-kraft",
    name: "Sacola Kraft Personalizada",
    category: "brindes",
    price: 18.9,
    badge: "Sustentavel",
    subtitle: "Acabamento elegante para kits e entregas especiais.",
    minOrder: "Pedido minimo: 25 unidades",
    delivery: "Entrega media: 7 dias",
    artLabel: "BAG",
    artSubLabel: "Entrega premium",
    tone: "sand",
  },
];
